export class IgnorableException {
  error: unknown;
  code?: number;
  message?: string;

  constructor(error: unknown, code?: number, message?: string) {
    this.error = error;
    this.code = code;
    this.message = message;
  }
}
